"use client";

import React, { useEffect, useState } from "react";
import { Menu as MenuIcon } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="206842" className="hidden md:flex gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-6 w-20 animate-pulse rounded-md bg-muted" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden md:flex">
      <NavigationMenuList className="gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.label === "Tarif" ? "/tarif" : item.id === "50" ? "/PricingPage" : item.href || "#"} className="group relative py-2 text-sm font-medium text-foreground transition-colors hover:text-accent font-default">
                {item.label === "Nice Art" ? "Notre Mission" : item.label === "Signature Services" ? "Nos Prestations" : item.label}
                <span className="absolute bottom-0 left-0 h-[2px] w-full origin-right scale-x-0 bg-accent transition-transform duration-300 ease-out group-hover:origin-left group-hover:scale-x-100" />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="mt-8 flex flex-col gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-8 w-32 animate-pulse rounded-md bg-muted" />)}
      </div>;
  }
  return <div className="mt-8 flex flex-col gap-6">
      {menuItems.map((item, i) => <Link key={item.id} to={item.label === "Tarif" ? "/tarif" : item.id === "50" ? "/PricingPage" : item.href || "#"} className="text-lg font-medium text-foreground transition-colors hover:text-accent font-default" data-index={i}>
          {item.label}
        </Link>)}
      <div className="mt-4 border-t border-border pt-6">
        <Button className="w-full bg-accent text-accent-foreground hover:bg-accent/90 rounded-sm font-default">
          Estimation gratuite
        </Button>
      </div>
    </div>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section id="header" className={`sticky top-0 z-50 w-full transition-all duration-300 ${isScrolled ? "border-b border-border bg-background/80 shadow-sm backdrop-blur-md" : "bg-background border-b border-border"}`}>
      <div className="container mx-auto flex h-20 items-center justify-between px-4 lg:px-8">
        {}
        <Link to="#" className="flex items-center">
          <img src="/img/d_location_logo.png" alt="D Location Conciergerie" className="h-7 w-auto" />
        </Link>

        {}
        <MenuProvider menu_id="16">
          <HeaderMenuConsumer />
        </MenuProvider>

        {}
        <div className="hidden items-center gap-4 md:flex">
          <Button className="bg-accent px-6 text-accent-foreground shadow-md transition-all duration-300 hover:scale-105 hover:bg-accent/90 hover:shadow-lg rounded-sm font-default">
            Estimation gratuite
          </Button>
        </div>

        {}
        <div className="md:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" aria-label="Ouvrir le menu">
                <MenuIcon className="h-6 w-6 text-foreground" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] border-l border-border bg-background sm:w-[400px]">
              <div className="flex flex-col h-full py-6">
                <Link to="#" className="mb-8 flex items-center">
                  <img src="/img/d_location_logo.png" alt="D Location Conciergerie" className="h-7 w-auto" />
                </Link>
                <MenuProvider menu_id="16">
                  <MobileMenuConsumer />
                </MenuProvider>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </section>;
}